import { render } from "./ContainerFluidex.vue?vue&type=template&id=12ad86a4&scoped=true"
import script from "./ContainerFluidex.vue?vue&type=script&lang=js"
export * from "./ContainerFluidex.vue?vue&type=script&lang=js"

import "./ContainerFluidex.vue?vue&type=style&index=0&id=12ad86a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ad86a4"]])

export default __exports__